import { AlertTriangleIcon, CircleAlertIcon, CircleCheckIcon, InfoIcon } from 'lucide-react';

export type Variants = keyof typeof IconsByState;

export const IconsByState = {
  neutral: <InfoIcon size={16} className="text-foreground" />,
  success: <CircleCheckIcon size={16} className="text-success" />,
  info: <InfoIcon size={16} className="text-muted-foreground" />,
  warning: <CircleAlertIcon size={16} className="text-warning" />,
  attention: <CircleAlertIcon size={16} className="text-warning" />,
  critical: <AlertTriangleIcon size={16} className="text-destructive" />,
} as const;
